export const ALERT_CODES = ['regular_alert', 'zt_alert'];

export const DEFAULT_SAVE_STATUS = {
  isFailed: false,
  lastSavedBlocks: [],
  retrying: false,
  savingBlocks: [],
};
